import type { UpdateBirthResponse } from '@lunya/contracts'
import { API_PATHS } from '@lunya/contracts'

import { createMutation } from '~/shared/api'
import { notifications } from '~/shared/lib/notifications'

import { resolveBirthErrorText } from '../utils/birthErrorText'
import { mapBirthToApi, type UpdateBirthInput } from './mappers/mapBirthToApi'
import { mapUserFromApi } from './mappers/mapUserFromApi'
import { UserQuery } from './UserQuery'

export type { UpdateBirthInput } from './mappers/mapBirthToApi'

/** PATCH /users/me/birth — дата/время/город рождения (A2). */
export const UpdateBirthMutation = createMutation<
  UpdateBirthInput,
  UpdateBirthResponse,
  ReturnType<typeof mapUserFromApi>
>({
  key: 'user.updateBirth',
  path: API_PATHS.user.birth,
  method: 'PATCH',
  getBody: mapBirthToApi,
  transform: mapUserFromApi,
  sideEffects: {
    invalidateQueries: [UserQuery],
    /**
     * Отказ обязан прозвучать. Ручка отвечает `AGE_RESTRICTED`, `BIRTH_DATE_IN_FUTURE` и
     * `VALIDATION_ERROR` (ненайденный город), а `mutate` не бросает — без этого обработчика
     * экран просто ничего не делал в ответ на нажатие.
     *
     * Онбординг эту строку отключает (`disabledSideEffects: ['onAnyError']`): у него для
     * возраста есть полноэкранная заглушка, а для даты из будущего — ошибка поля.
     */
    onAnyError: (error) => notifications.error(resolveBirthErrorText(error)),
  },
})
